import { DialogActions } from '@mui/material';
import type { FC } from 'react';

import { useZustand } from '../../zustandStore';

import { IntroductionActions } from './introductionActions';
import { ManagementActions } from './managementActions';

export const CookieActions: FC = () => {
	const { cookies } = useZustand(state => ({ ...state }));

	const { showManageCookies } = cookies;

	return (
		<DialogActions
			style={{
				justifyContent: 'center',
				padding: '0px 24px 24px',
				display: 'flex',
				flexWrap: 'wrap',
				maxWidth: '100%',
				width: '100%',
				boxSizing: 'border-box',
				gap: '10px',
			}}
		>
			{showManageCookies ? <ManagementActions /> : <IntroductionActions />}
		</DialogActions>
	);
};
